import React from "react";
import * as Styled from "./../reservationGridFilterStyles";
// import dayjs from 'dayjs';
import GODate from "../../common/GODate";
import { GOFilterContainer } from "../../../components";

interface PlateReservationStatusTimeProps {
  date: any;
  goLeft: any;
  goRight: any;
  goDate?: any;
}

const PlateReservationStatusTime = (props: PlateReservationStatusTimeProps) => {
  return (
    <GOFilterContainer
      leftbody={
        <Styled.LeftControlCustomStyles>
          <Styled.PeriodGroup className="input_margin_wrapper">
            <div className="arrow_btn left" onClick={props.goLeft} />
            <GODate
              onChange={(date: any) => {
                props.goDate(date);
              }}
              selected={new Date(props.date.endDate)}
            />
            <div className="arrow_btn right" onClick={props.goRight} />
          </Styled.PeriodGroup>
        </Styled.LeftControlCustomStyles>
      }
    />
  );
};
export default PlateReservationStatusTime;
